<template>
  <section class="polityka">
    <h1>Polityka prywatności</h1>

    <div class="polityka-blok">
      <h2>1. Administrator danych</h2>
      <p>Administratorem danych osobowych jest BIRDSOFT sp. z o.o., ul. Kaliska 35A/210, 63-400 Ostrów Wielkopolski, Polska, NIP: PL6222856070.</p>

      <h2>2. Cele przetwarzania danych</h2>
      <p>Twoje dane przetwarzamy wyłącznie w celu realizacji zamówienia, obsługi klienta, wystawienia faktury, wysyłki produktów oraz – jeśli wyrazisz zgodę – kontaktu marketingowego.</p>

      <h2>3. Podstawa prawna</h2>
      <p>Przetwarzanie danych odbywa się na podstawie art. 6 ust. 1 lit. b i f RODO – realizacja umowy oraz prawnie uzasadniony interes administratora.</p>

      <h2>4. Odbiorcy danych</h2>
      <p>Dane mogą być przekazywane podmiotom realizującym płatności (np. PayPal), firmom kurierskim oraz podmiotom księgowym obsługującym naszą firmę.</p>

      <h2>5. Czas przechowywania danych</h2>
      <p>Dane przechowujemy przez okres niezbędny do realizacji zamówienia oraz wynikający z przepisów prawa (np. podatkowych) – zazwyczaj nie dłużej niż 6 lat.</p>

      <h2>6. Twoje prawa</h2>
      <p>Masz prawo do wglądu, poprawienia, usunięcia lub ograniczenia przetwarzania swoich danych. Możesz też wnieść sprzeciw lub złożyć skargę do Prezesa UODO.</p>

      <h2>7. Dobrowolność podania danych</h2>
      <p>Podanie danych jest dobrowolne, ale niezbędne do realizacji zamówienia. Bez danych osobowych nie możemy wysłać Ci produktu ani wystawić faktury.</p>

      <h2>8. Pliki cookies</h2>
      <p>Nasza strona korzysta z plików cookies w celu poprawy działania serwisu oraz analizowania ruchu. Możesz zarządzać nimi w ustawieniach swojej przeglądarki.</p>

      <h2>9. Kontakt</h2>
      <p>W sprawach związanych z danymi osobowymi skontaktuj się z nami mailowo: <a href="mailto:biuro@birdstool.pl">biuro@birdea.pl</a></p>
    </div>
  </section>
</template>

<script setup>
// Statyczny komponent – zero logiki
</script>

<style scoped>
.polityka {
  background-color: #ffffff;
  color: #111111;
  font-family: sans-serif;
  padding: 32px 24px;
  max-width: 800px;
  margin: 48px auto 0;
}

.polityka h1 {
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 24px;
}

.polityka-blok h2 {
  font-size: 18px;
  margin-top: 24px;
  margin-bottom: 10px;
  font-weight: 600;
}

.polityka-blok p {
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 12px;
}

.polityka-blok a {
  color: #111;
  text-decoration: none;
}

.polityka-blok a:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .polityka {
    padding: 24px 16px;
  }

  .polityka h1 {
    font-size: 22px;
  }

  .polityka-blok h2 {
    font-size: 16px;
  }

  .polityka-blok p {
    font-size: 14px;
  }
}
</style>
